module.exports = __webpack_public_path__ + "img/2-3porte.bae3bb4c.webp";